import React, { useContext, useState, useEffect, useRef } from "react";
import {
  Table,
  Input,
  Button,
  Typography,
  Form,
  Image,
  Row,
  Col,
  Checkbox,
  Select,
  Skeleton,
  
} from "antd";
import { Colors } from "../../../../theme";
import { DeleteFilled } from "@ant-design/icons";
import { useGlobal } from "../../../../store/index";

const EditableContext = React.createContext(null);
const { Option } = Select;
const { Text } = Typography;

const EditableRow = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

const EditableCell = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  handleSave,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef(null);
  const form = useContext(EditableContext);
  useEffect(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);

  const toggleEdit = () => {
    setEditing(!editing);
    form.setFieldsValue({
      [dataIndex]: record[dataIndex],
    });
  };

  const save = async () => {
    try {
      const values = await form.validateFields();
      toggleEdit();
      handleSave({ ...record, ...values });
    } catch (errInfo) {
      console.log("Save failed:", errInfo);
    }
  };

  let childNode = children;

  if (editable) {
    childNode = editing ? (
      <Form.Item
        style={{
          margin: 0,
        }}
        name={dataIndex}
        // rules={[
        //   {
        //     required: true,
        //     message: `${title} is required.`,
        //   },
        // ]}
      >
        <Input ref={inputRef} onPressEnter={save} onBlur={save} />
      </Form.Item>
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{
          paddingRight: 24,
        }}
        onClick={toggleEdit}
      >
        {children}
      </div>
    );
  }

  return <td {...restProps}>{childNode}</td>;
};

export default function EditableTable({
  dataSource,
  tabName,
  showPrice,
  showMoq,
  showSamplingTime,
  showLeadTime,
}) {
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(true);
  const [bulkEditOperation, setbulkEditOperation] = useState("increase");
  const [bulkEditcolumn, setbulkEditcolumn] = useState("price");
  const [bulkEditBy, setbulkEditBy] = useState("percent");
  const [bulkEditValue, setbulkEditValue] = useState(0);
  const [globalState, setGlobalState] = useGlobal();
  const { editCollectionProducts } = globalState;

  // const { editCollectionProducts } = globalState;

  // get updated data as props and set it to state
  useEffect(() => {
    if (dataSource.length > 0) {
      setData(dataSource);
    }
  }, [dataSource]);

  // map columns to with methods
  const _columns = [
    {
      title: <Checkbox onChange={(event) => handleCheckAll(event)} />,
      dataIndex: "isSelected",
      key: "isSelected",
      fixed: "left",
      width: 50,
      render: (isSelected, record) => (
        <Checkbox
          checked={isSelected}
          onChange={(event) => handleCheck(record, event)}
        />
      ),
    },
    {
      title: "",
      dataIndex: "deleteId",
      key: "deleteId",
      fixed: "left",
      width: 50,
      render: (deleteId, record) => (
        <DeleteFilled
          style={{ color: "#B4B7B6", fontSize: "1.2rem" }}
          onClick={() => handleDelete(deleteId)}
        />
      ),
    },
    {
      title: "ID",
      dataIndex: "product_id",
      key: "product_id",
      fixed: "left",
      width: 100,
    },
    {
      title: "Image",
      dataIndex: "url",
      key: "url",
      visible: true,
      fixed: "left",
      width: 100,
      render: (url) => (
        <>
          <Image
            width={50}
            style={{ borderRadius: 4 }}
            src={
              url
                ? `${process.env.REACT_APP_DIRECTUS}assets/${url}?fit=cover&width=50&height=50&quality=100`
                : "https://via.placeholder.com/40x40.png"
            }
            preview={{
              src: url
                ? `${process.env.REACT_APP_DIRECTUS}assets/${url}?fit=cover&width=300&height=300&quality=100`
                : "https://via.placeholder.com/300x300.png",
            }}
          />
        </>
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      fixed: "left",
      editable: true,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",

      ellipsis: true,
      editable: showLeadTime,
      render: (text, record) => {
        return <span> {text}</span>;
      },
    },

    {
      title: (
        <span
          style={{
            color: showLeadTime ? "black" : "lightgrey",
          }}
        >
          Lead Time
        </span>
      ),
      dataIndex: "production_lead_time",
      key: "production_lead_time",
      disable: showLeadTime,
      editable: showLeadTime,
      ellipsis: true,
      render: (text, record) => {
        return (
          <span
            style={{
              color: showLeadTime ? "black" : "lightgrey",
            }}
          >
            {" "}
            {text}
          </span>
        );
      },
    },
    {
      title: (
        <span
          style={{
            color: showSamplingTime ? "black" : "lightgrey",
          }}
        >
          Sampling Time
        </span>
      ),
      dataIndex: "sampling_lead_time",
      key: "sampling_lead_time",
      disable: showSamplingTime,
      editable: showSamplingTime,

      render: (text, record) => {
        return (
          <span
            style={{
              color: showSamplingTime ? "black" : "lightgrey",
            }}
          >
            {" "}
            {text}
          </span>
        );
      },
    },
    {
      title: (
        <span
          style={{
            color: showMoq ? "black" : "lightgrey",
          }}
        >
          MOQ
        </span>
      ),
      dataIndex: "moq",
      key: "moq",
      ellipsis: true,
      editable: showMoq,
      render: (text, record) => {
        return (
          <span
            style={{
              color: showMoq ? "black" : "lightgrey",
            }}
          >
            {" "}
            {text}
          </span>
        );
      },
    },
    {
      title: (
        <span
          style={{
            color: showPrice ? "black" : "lightgrey",
          }}
        >
          Currency
        </span>
      ),
      dataIndex: "currency",
      key: "currency",
      width: 100,
      render: (text, record) => {
        return (
          <span
            style={{
              color: showPrice ? "black" : "lightgrey",
            }}
          >
            {" "}
            {text}
          </span>
        );
      },
    },
    {
      title: (
        <span
          style={{
            color: showPrice ? "black" : "lightgrey",
          }}
        >
          Price
        </span>
      ),
      dataIndex: "price",
      key: "price",
      width: 150,
      editable: showPrice,
      render: (text, record) => {
        return (
          <span
            style={{
              color: showPrice ? "black" : "lightgrey",
            }}
          >
            {" "}
            {text}
          </span>
        );
      },
    },

    {
      title: (
        <span
          style={{
            color: showPrice ? "black" : "lightgrey",
          }}
        >
          Unit
        </span>
      ),
      dataIndex: "pp",
      key: "pp",

      render: (text, record) => {
        return (
          <span
            style={{
              color: showPrice ? "black" : "lightgrey",
            }}
          >
            {" "}
            {text}
          </span>
        );
      },
    },

    {
      title: "Colours",
      dataIndex: "color_tag",
      key: "color_tag",
      render: (text, record) => <span>{text && text.join(", ")}</span>,
    },
    // {
    //   title: "Shape",
    //   dataIndex: "shape",
    //   key: "shape",

    //   render: (text, record) => <span>{text && text.join(",")}</span>,
    // },
    // {
    //   title: "Dimensions",
    //   dataIndex: "dimensions",
    //   key: "dimensions",
    //   render: (text, record) => <span>{text}</span>,
    // },
    // {
    //   title: "Design",
    //   dataIndex: "design",
    //   key: "design",
    //   render: (text, record) => <span>{text && text.join(",")}</span>,
    // },
    // {
    //   title: "Technique",
    //   dataIndex: "technique",
    //   key: "technique",
    //   render: (text, record) => <span>{text && text.join(",")}</span>,
    // },
    // {
    //   title: "Shape",
    //   dataIndex: "size",
    //   key: "size",
    // },
    // {
    //   title: "Quality",
    //   dataIndex: "quality",
    //   key: "quality",
    // },

    // {
    //   title: "Currency",
    //   dataIndex: "internal_currency",
    //   key: "internal_currency",
    // },
    // {
    //   title: "Price",
    //   dataIndex: "internal_price",
    //   key: "internal_price",
    // },
    // {
    //   title: "Quantity",
    //   dataIndex: "internal_quantity",
    //   key: "internal_quantity",
    // },

    // {
    //   title: "Tags",
    //   dataIndex: "tags",
    //   key: "tags",
    //   render: (text, record) => (
    //     <span>
    //       {text && text.join(',')}

    //     </span>
    //   ),
    // },
  ];
  // columns
  const columns = _columns.map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave: handleSave,
      }),
    };
  });

  //send updated data to parent component
  useEffect(() => {
    if (data.length > 0) {
      const selectedProducts = JSON.parse(
        localStorage.getItem("selectedProducts")
      );

      if (selectedProducts) {
        const result = selectedProducts.map(
          (item) => data.find((item2) => item.id === item2.id) || item
        );

        localStorage.setItem("selectedProducts", JSON.stringify(result));
      }
    }
  }, [data]);

  // handle bulk edit value change
  const handlebulkEditValue = (event) => {
    setbulkEditValue(event.target.value);
  };

  //prefix component
  const prefixSelector = <span>by</span>;
  // surfix component
  const suffixSelector = (
    <span>%</span>
    // <Select
    //   defaultValue={bulkEditBy}
    //   style={{ width: 100 }}
    //   onChange={handleChangeEditBy}
    // >
    //   <Option value="percent">%</Option>
    //   {/* <Option value="value">value</Option> */}
    // </Select>
  );
  // handle bulk edit modal
  const handleModal = () => {
    setShowModal((state) => !state);
  };
  // handle change operation
  const handleChangeOperation = (value) => {
    setbulkEditOperation(value);
  };
  // handle bulk edit column change
  const handleChangeColumn = (value) => {
    setbulkEditcolumn(value);
  };

  const bulkeditCalculation = () => {
    if (bulkEditOperation === "increase") {
      if (bulkEditBy === "value") {
        const newdata = data.map((item) => {
          item[bulkEditcolumn] =
            parseInt(item[bulkEditcolumn]) + parseInt(bulkEditValue);
          return item;
        });
        setData(newdata);
      } else if (bulkEditBy === "percent") {
        const newdata = data.map((item) => {
          item[bulkEditcolumn] = item[bulkEditcolumn]
            ? (
                parseFloat(item[bulkEditcolumn]) +
                (parseFloat(item[bulkEditcolumn]) * parseFloat(bulkEditValue)) /
                  100
              ).toFixed(2)
            : "";
          return item;
        });
        setData(newdata);
      }
    } else {
      //decreases
      if (bulkEditBy === "value") {
        const newdata = data.map((item) => {
          item[bulkEditcolumn] = item[bulkEditcolumn]
            ? parseInt(item[bulkEditcolumn]) - parseInt(bulkEditValue)
            : 0;
          return item;
        });
        setData(newdata);
      } else if (bulkEditBy === "percent") {
        const newdata = data.map((item) => {
          item[bulkEditcolumn] = item[bulkEditcolumn]
            ? (
                parseFloat(item[bulkEditcolumn]) -
                (parseFloat(item[bulkEditcolumn]) * parseFloat(bulkEditValue)) /
                  100
              ).toFixed(2)
            : "";
          return item;
        });
        setData(newdata);
      }
    }
  };

  const calculate = {
    increase: {
      // value: (a, b) => a + b,
      percent: (a, b) => a + (a * b) / 100,
    },
    decrease: {
      // value: (a, b) => a - b,
      percent: (a, b) => a - (a * b) / 100,
    },
  };
  // handle done button click
  const executeBulkEdit = () => {
    const isSelected = (element) => element.isSelected === true;
    // console.log(data.some(isSelected));

    //calculate[bulkEditOperation][bulkEditBy](data, bulkEditValue);

    if (data.some(isSelected)) {
      setData((state) =>
        state.map((item) =>
          item.isSelected === true
            ? {
                ...item,
                [bulkEditcolumn]: calculate[bulkEditOperation][bulkEditBy](
                  parseFloat(item[bulkEditcolumn]),
                  parseFloat(bulkEditValue)
                ),
              }
            : item
        )
      );
    } else {
      bulkeditCalculation();
    }

    handleModal();
    // setbulkEditOperation("increase");
    // setbulkEditcolumn("price");
    setbulkEditBy("percent");
    setbulkEditValue(0);
  };

  // handle checkbox from each row
  const handleCheck = (record, event) => {
    console.log(JSON.stringify(record));
    const findeIndex = data.findIndex((item) => item === record);
    console.log(findeIndex);

    if (event.target.checked) {
      if (findeIndex > -1) {
        setData((state) =>
          state.map((item) =>
            item === record
              ? {
                  ...item,
                  isSelected: true,
                }
              : item
          )
        );
      }
    } else {
      setData((state) =>
        state.map((item) =>
          item === record
            ? {
                ...item,
                isSelected: false,
              }
            : item
        )
      );
    }
  };

  const handleCheckAll = (event) => {
    if (event.target.checked) {
      // setData((state) => state.filter((item) => (item.isSelected = true)));
      setData((state) =>
        state.map((item) => ({
          ...item,
          isSelected: true,
        }))
      );
    } else {
      // setData((state) => state.filter((item) => (item.isSelected = false)));
      setData((state) =>
        state.map((item) => ({
          ...item,
          isSelected: false,
        }))
      );
    }
  };
  const currencyValues = {
    INR: { USD: 0.013, GBP: 0.0096, EUR: 0.011 },
    USD: { INR: 74.25, GBP: 0.72, EUR: 0.84 },
    GBP: { INR: 103.79, USD: 1.4, EUR: 1.18 },
    EUR: { INR: 88.27, USD: 1.19, GBP: 0.85 },
  };

  const currencyConverter = (from, to, price) => {
    console.log(from, to, price);
    from = from && from.toUpperCase();
    to = to && to.toUpperCase();
    if (from && to && price) return currencyValues[from][to] * price;
  };

  useEffect(() => {
    const flags = {
      show_price: showPrice,
      show_moq: showMoq,
      show_sampling_lead_time: showLeadTime,
      show_production_lead_time: showSamplingTime,
    };
    localStorage.setItem("flags", JSON.stringify(flags));
  }, [showLeadTime, showPrice, showMoq, showSamplingTime]);
  // handle currency change

  const onChangeCurrency = (value) => {
    setData((state) =>
      state.map((item) => ({
        ...item,
        price:
          item.currency !== value
            ? currencyConverter(item.currency, value, parseFloat(item.price)) &&
              currencyConverter(
                item.currency,
                value,
                parseFloat(item.price)
              ).toFixed(2)
            : item.price,
        currency: value,
      }))
    );
  };

  // handle editable cell from table
  const handleSave = (row) => {
    console.log(row);
    const newData = [...data];
    const index = newData.findIndex((item) => row?.id === item?.id);
    const item = newData[index];
    newData.splice(index, 1, { ...item, ...row });
    setData(newData);
    const newState = [];
    editCollectionProducts.forEach((element) => {
      var i = element.values.findIndex((pro) => pro.id === row?.id);
      if (index !== -1) {
        element.values[i] = row;
      }
      newState.push(element);
    });
    let storageShortlist = [];
    console.log(newState);
    console.log(editCollectionProducts);
    newState.forEach((element) => {
      element.values.forEach((item) => storageShortlist.push(item));
    });
    console.log(storageShortlist);
    setGlobalState.collections.setEditCollectionProducts(newState);

    // localStorage.setItem("selectedProducts", JSON.stringify(storageShortlist));
  };

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };

  const calculatePriceOnUnitChange = (value, quantity, price) => {
    if (value === "per-square-metre") {
      console.log(quantity, "per-piece");
      return quantity === "per-piece"
        ? price
        : (parseFloat(price) * 10.76391).toFixed(2);
    } else if (value === "per sq. feet") {
      return quantity === "per-piece"
        ? price
        : (parseFloat(price) / 10.76391).toFixed(2);
    } else {
      return price;
    }
  };

  // handle unit change
  const onChangeUnit = (value) => {
    console.log(value);
    // if (value !== "per-piece") {
    setData((state) =>
      state.map((item) => ({
        ...item,

        price:
          item.pp === value
            ? item.price
            : isNaN(calculatePriceOnUnitChange(value, item.pp, item.price))
            ? item.price
            : calculatePriceOnUnitChange(value, item.pp, item.price),
        // pp: item?.pp === "per-piece" ? item.pp : value,
        pp: value,
      }))
    );
    //}
  };

  const handleDelete = (id) => {
    setData((state) => state.filter((item) => item?.id !== id));
    const newState = [];
    editCollectionProducts.forEach((element) => {
      element.values = element.values.filter((pro) => pro.id !== id);
      newState.push(element);
    });
    let storageShortlist = [];
    newState.forEach((element) => {
      element.values.forEach((item) => storageShortlist.push(item));
    });

    setGlobalState.collections.setEditCollectionProducts(newState);

    localStorage.setItem("selectedProducts", JSON.stringify(storageShortlist));
  };

  //setEditCollectionProducts editCollectionProducts
  return (
    <div>
      <Col span={24}>
        <Row
          justify="space-around"
          align="middle"
          style={{ marginBottom: "1rem" }}
        >
          <Col span={24}>
            <Row>
              <Col span={18}>
                {/* <Checkbox.Group
                  options={ShowColumnOptions}
                  defaultValue={ShowColumnOptions.flatMap((item) => item.value)}
                  onChange={onChangeShowColumnOptions}
                /> */}
                <Select
                  placeholder="Currency"
                  size="middle"
                  style={{ width: "48%", marginRight: "1rem" }}
                  onChange={onChangeCurrency}
                >
                  <Option value={"USD"}>$ USD</Option>
                  <Option value={"INR"}>₹ INR</Option>
                  <Option value={"GBP"}>£ GBP</Option>
                  <Option value={"EUR"}>€ EURO</Option>
                </Select>

                <Select
                  placeholder="Unit"
                  size="middle"
                  style={{ width: "48%" }}
                  onChange={onChangeUnit}
                >
                  <Option value={"per-piece"}>per-piece</Option>
                  <Option value={"per-square-metre"}>per-square-metre</Option>
                  <Option value={"per sq. feet"}>per sq. feet</Option>
                </Select>
              </Col>

              <Col span={6}>
                <Button
                  size="middle"
                  style={{ width: "100%" }}
                  onClick={() => handleModal()}
                >
                  Bulk Edit Data
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        {/* Proposed bulk edit */}
        <div hidden={showModal}>
          <Row justify="end" style={{ width: "100%" }}>
            <Col className="bulk-edit-card">
              <Row style={{ marginBottom: "1.2rem" }}>
                <Col>
                  <Text>
                    Edit details of all the products in{" "}
                    <Text style={{ fontSize: "1rem" }}>{tabName}</Text> at once{" "}
                  </Text>
                </Col>
              </Row>

              <Row justify="space-between">
                <Col>
                  <Select
                    value={bulkEditOperation}
                    style={{ width: "100%" }}
                    onChange={handleChangeOperation}
                  >
                    <Option value="increase">Increase</Option>
                    <Option value="decrease">Decrease</Option>
                  </Select>
                </Col>
                <Col>
                  <Select
                    defaultValue={bulkEditcolumn}
                    style={{ width: "100%" }}
                    onChange={handleChangeColumn}
                  >
                    <Option value="price">Price</Option>
                    <Option value="moq">MOQ</Option>
                  </Select>
                </Col>
                <Col>
                  <Input
                    value={bulkEditValue}
                    type="number"
                    addonBefore={prefixSelector}
                    addonAfter={suffixSelector}
                    onChange={handlebulkEditValue}
                  />
                </Col>
                <Col>
                  <Button
                    style={{ background: Colors.black, color: Colors.white }}
                    onClick={executeBulkEdit}
                  >
                    Done
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>

       
        {data ?  <Table
            pagination={false}
            size="small"
            // bordered
            components={components}
            rowClassName={() => "editable-row"}
            dataSource={data}
            columns={columns}
            scroll={{ x: 2000 }}
          /> :<Skeleton active /> } 
        
      </Col>
    </div>
  );
}